import { Trans, useTranslation } from 'react-i18next'
import {
  Header,
  Info,
  InfoBold,
  InfoList,
  InfoWrapper,
  AdditionalInfoColumns,
} from 'components/Pages/Wine/View/Main/Content/ColumnRight/_styles'
import { EmptyInfo } from 'components/Pages/Wine/View/Main/Content/ColumnLeft/_styles'
import { StyledLink } from 'components/Common/MasterComponents'
import Collapsable from 'components/Pages/Wine/View/Common/Collapsable'
import useUserRole from 'utils/user/useUserRole'
import { useCapturedWine } from '../../../_methods/context'
import { useProduct } from 'components/Pages/Wine/View/Main/_methods'

const ServingSuggestions = () => {
  const { t } = useTranslation()
  const product = useProduct()
  const { isAuthor, capturedWine, canEdit: canEditCtx } = useCapturedWine()
  const { isContent, isSuperAdmin } = useUserRole()
  const canEdit =
    canEditCtx !== undefined
      ? canEditCtx
      : isAuthor || isContent || isSuperAdmin

  const foodPairs = product?.wine?.foodPairs ?? []
  const servingTemperatureMax = product?.wine?.servingTemperatureMax ?? ''
  const servingTemperatureMin = product?.wine?.servingTemperatureMin ?? ''

  const foodPairsText = foodPairs
    .map((item: any) => item?.localizedName)
    .filter(Boolean)
    .join(', ')

  const hasContent =
    foodPairs.length > 0 || (servingTemperatureMax && servingTemperatureMin)

  return (
    <Collapsable title={t('wine.view.servingSuggestions')}>
      {hasContent ? (
        <AdditionalInfoColumns>
          {foodPairs.length > 0 && (
            <InfoWrapper>
              <Header>{t('wine.view.foodPairings')}</Header>
              <InfoList>
                <Info>{foodPairsText}</Info>
              </InfoList>
            </InfoWrapper>
          )}
          {servingTemperatureMax && servingTemperatureMin && (
            <InfoWrapper>
              <Header>{t('wine.view.servingTemperature')}</Header>
              <InfoList>
                <InfoBold>
                  {servingTemperatureMin === servingTemperatureMax ? (
                    <span>{servingTemperatureMin}&#176;C</span>
                  ) : (
                    <span>
                      {servingTemperatureMin}&#176;C &#8211;{' '}
                      {servingTemperatureMax}&#176;C
                    </span>
                  )}
                </InfoBold>
              </InfoList>
            </InfoWrapper>
          )}
        </AdditionalInfoColumns>
      ) : !hasContent && canEdit ? (
        <EmptyInfo>
          <Trans
            t={t}
            i18nKey='wine.view.noServingSuggestions'
            components={[
              <StyledLink
                key={0}
                to={`/acc/captured-wine/${capturedWine.id}/edit/general`}
              />,
            ]}
          />
        </EmptyInfo>
      ) : !hasContent ? (
        <EmptyInfo>{t('capturedWine.view.noServingSuggestions')}</EmptyInfo>
      ) : null}
    </Collapsable>
  )
}

export default ServingSuggestions
